import React from "react";
import "../../helpCenter/getStarted/getStarted.scss";
import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
import { useAuth } from "../../../contexts/auth";

export default function GetStarted() {
  const { user } = useAuth();

  const role = user?.userrole?.toLowerCase();

  // 🎯 Decide file based on role
  let file = "";
  let title = "";

  if (role === "customer" || role === "customercontact") {
    file = "customer-guide.pdf";
    title = "Customer / Contact Guide";
  } else if (role === "company" || role === "companyuser") {
    file = "admin-developer-manual.pdf";
    title = "Admin / Developer Manual";
  }

  // ✅ Open Manual
  const openManual = (file) => {
    const fileURL = `${window.location.origin}/manuals/${file}`;
    window.open(fileURL, "_blank");
  };

  // ✅ Download Manual
  const downloadManual = (file) => {
    const fileURL = `${window.location.origin}/manuals/${file}`;

    const link = document.createElement("a");
    link.href = fileURL;
    link.download = file;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <div className="get-started-page">
      <BreadCrumb />

      <div className="get-started-title">
        <h4>User Manual</h4>
      </div>

      {file ? (
        <div className="manual-container">
          <div className="manual-card">
            <div className="manual-info">
              <h5>{title}</h5>
              <p>
                Access the complete user guide to understand features and
                workflows.
              </p>
            </div>

            <div className="manual-actions">
              <i
                className="ri-download-2-line download-icon"
                onClick={() => downloadManual(file)}
                title="Download Manual"
              ></i>

              <button
                className="manual-btn open"
                onClick={() => openManual(file)}
              >
                📄 Open Manual
              </button>
            </div>
          </div>
        </div>
      ) : (
        <p className="no-manual">No manual found for role: {role}</p>
      )}
    </div>
  );
}
